<template>
  <div id="history">
    <!-- Live Games -->
    <div class="live-games margin-5 bg-light margin-bottom-5" v-if="live_tournaments.length">
      <div class="text-uppercase padding-10 bottom-border text-green">{{getTranslatedText('live')}}</div>
      <div v-for="lt in live_tournaments">
        <div class="game align-hor space-between padding-10" v-on:click="showLeaderBoard(lt)">
          <div class="logo center-align-self">
            <img class="extra-large-icon full-width" :src="lt.game_thumb_url">
          </div>
          <div class="align-ver text-left text-semi-small">
            <div class="margin-bottom-10">{{lt.title}}</div>
            <div class="timing text-uppercase bottom-border text-light-grey margin-bottom-5 padding-bottom-5">{{lt.timing.start.time}} {{lt.timing.start.date}} - {{lt.timing.end.time}} {{lt.timing.end.date}}</div>
            <div class="align-hor space-between">
              <div class="margin-right-10">
                <div class="padding-bottom-5">{{getTranslatedText('Total Prize')}}</div>
                <div class="container">
                  <img class="semi-large-icon" src="@/assets/ticket-white.svg">
                  <div class="centered text-smaller">{{lt.total_prize}}</div>
                </div>
              </div>
              <div class="margin-right-10">
                <div class="padding-bottom-5">{{getTranslatedText('Entry Fee')}}</div>
                <div class="text-uppercase">{{lt.entry_fee == 0 ? getTranslatedText('free') : lt.entry_fee}}</div>
              </div>
              <div>
                <div class="padding-bottom-5">{{getTranslatedText('Your Rank')}}</div>
                <div class="text-green">#{{lt.your_rank}}</div>
              </div>
            </div>
          </div>
          <div class="text-uppercase text-light">
            <div class="tag padding-0515">{{getTranslatedText('live')}}</div>
          </div>
        </div>
        <hr class="custom-hr">
        <div class="modal center-hor align-ver" v-show="lt.leaderboard" v-on:click="hideLeaderBoard(lt)">
          <leader-board v-show="lt.leaderboard && lt.leaderboard_data.length > 0" :model="lt.leaderboard_data"></leader-board>
        </div>
      </div>
    </div>

    <!-- Completed Games -->
    <div class="live-games margin-5 bg-light margin-bottom-5" v-if="completed_tournaments.length">
      <div class="text-uppercase padding-10 bottom-border">{{getTranslatedText('completed')}}</div>
      <div v-for="ct in completed_tournaments">
        <!-- <div class="game align-hor space-between padding-10" v-on:click="ct.leaderboard = !ct.leaderboard"> -->
        <div class="game align-hor space-between padding-10" v-on:click="showLeaderBoard(ct)">
          <div class="logo center-align-self">
            <img class="extra-large-icon full-width" :src="ct.game_thumb_url">
          </div>
          <div class="align-ver text-left text-semi-small">
            <div class="margin-bottom-10">{{ct.title}}</div>
            <div class="timing text-uppercase bottom-border text-light-grey margin-bottom-5 padding-bottom-5">{{ct.timing.start.time}} {{ct.timing.start.date}} - {{ct.timing.end.time}} {{ct.timing.end.date}}</div>
            <div class="align-hor space-between">
              <div class="margin-right-10">
                <div class="padding-bottom-5">{{getTranslatedText('Total Prize')}}</div>
                <div class="container">
                  <img class="semi-large-icon" src="@/assets/ticket-white.svg">
                  <div class="centered text-smaller">{{ct.total_prize}}</div>
                </div>
              </div>
              <div class="margin-right-10">
                <div class="padding-bottom-5">{{getTranslatedText('Entry Fee')}}</div>
                <div class="text-uppercase">{{ct.entry_fee == 0 ? getTranslatedText('free') : ct.entry_fee}}</div>
              </div>
              <div>
                <div class="padding-bottom-5">{{getTranslatedText('Your Rank')}}</div>
                <div class="text-green">#{{ct.your_rank}}</div>
              </div>
            </div>
          </div>
          <div class="tags text-uppercase">
            <div class="container">
              <img class="semi-extra-large-icon" src="@/assets/ticket-white.svg">
              <div class="centered">{{ct.your_prize}}</div>
            </div>
          </div>
        </div>
        <hr class="custom-hr">
        <!-- <div class="modal center-hor align-ver" v-show="ct.leaderboard" v-on:click="ct.leaderboard = !ct.leaderboard"> -->
        <div class="modal center-hor align-ver" v-show="ct.leaderboard" v-on:click="hideLeaderBoard(ct)">
          <leader-board v-show="ct.leaderboard && ct.leaderboard_data.length > 0" :model="ct.leaderboard_data"></leader-board>
        </div>
      </div>
    </div>

    <div class="margin-5 align-ver center-hor" v-if="!live_tournaments.length && !completed_tournaments.length">
      <div style="height: 85vh;" class="align-ver center-hor bg-light border-radius-5">
        <div style="display: flex; justify-content: center; align-items: center; width: 100%">
          <img src="@/assets/no-data.svg" class="w20" style="width: 20%;">
        </div>
       <div class="font-bold">You haven't played any game yet!</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import LeaderBoard from '@/components/leader-board'
  import axios from "axios"
  export default {
    mixins: [globals],
    components: {
      'leader-board': LeaderBoard,
    },
    data() {
      return {
        live_tournaments: [],
        completed_tournaments: [],
        isOpen: false,
        page: 1,
      }
    },
    methods: {
      getTournamentHistory() {
        var self = this;
        var url = this.$store.getters.gamesDomain+'/v2/web_games_history?partner='+self.partnerID+'&contact_number='+self.extUid;
        if(self.gameID) {
          url += "&game_id="+self.gameID;
        }
        if(self.langCode) {
          url += "&lang="+self.langCode;
        }
        var headers = this.$store.getters.headers;
        axios.get(url, {
          headers: headers
        }).then((resp) => {
          if(resp.status == 200 && resp.data.success) {
            var data = resp.data;
            self.$store.state.totalUserPoints = data.total_user_points;
            var all_live_tournaments = data.live;
            if(all_live_tournaments.length > 0) {
              all_live_tournaments.forEach(function(v) {
                v.timing = self.getFormattedDateTime(v.starts_at, v.ends_at);
                v.leaderboard = false;
                var tempObj = {}
                tempObj.id = v.your_id;
                tempObj.name = v.your_name;
                tempObj.mobile = v.your_contact_number;
                tempObj.rank = v.your_rank;
                tempObj.prize = v.your_prize;
                tempObj.score = v.your_score;
                tempObj.prize_type = v.your_prize_type;
                v.leaderboard_data.unshift(tempObj);
              });
            }
            self.live_tournaments = all_live_tournaments;

            var all_completed_tournaments = data.completed;
            if(all_completed_tournaments.length > 0) {
              all_completed_tournaments.forEach(function(v) {
                v.timing = self.getFormattedDateTime(v.starts_at, v.ends_at);
                v.leaderboard = false;
                var tempObj = {}
                tempObj.id = v.your_id;
                tempObj.name = v.your_name;
                tempObj.mobile = v.your_contact_number;
                tempObj.rank = v.your_rank;
                tempObj.prize = v.your_prize;
                tempObj.score = v.your_score;
                tempObj.prize_type = v.your_prize_type;
                v.leaderboard_data.unshift(tempObj);
              });
            }
            self.completed_tournaments = all_completed_tournaments;
          } else {
            self.alertPopup(true, resp.data.message);
          }
        }).catch((err) => {})
      },
      showLeaderBoard(game) {
        game.leaderboard = true;
        var prize;
        this.messageToShare(game.your_prize, game.your_prize_type, game.title)
      },
      hideLeaderBoard(game) {
        game.leaderboard = false;
        this.messageToShare("", "", "");
      },
    },
    created() {
      clearInterval(this.$store.state.refreshTournamentTimer);
      this.$store.state.headTitle = "Tournament History";
      this.$store.state.history = false;
      this.$store.state.showHistory = false;
      this.$store.state.showWallet = false;
      this.getTournamentHistory();
    }
  }
</script>

<style>
  .tag {
    background: #f24972;
  }
  .logo {
    height: 80px;
    width: 80px;
  }
  .tags {
    min-width: 60px;
  }
  #history .ranking-rewards {
    border-collapse: collapse;
    width: 100%;
  }
  #history .ranking-rewards td {
    padding: 5px 10px;
  }
  #history .ranking-rewards tr:nth-child(2) {
    --bgcolor: #666666;
    background-color: var(--bgcolor);
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/screens/history.vue